import classNames from 'classnames';
import { DetailedHTMLProps, InputHTMLAttributes, memo } from 'react';

export type CheckBoxProps = { className?: string } & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;
const CheckBox_: React.FC<CheckBoxProps> = ({ className, ...props }) => {
  return (
    <input
      type="checkbox"
      className={classNames(
        className,
        // The forms plugin fills a checked box with the text colour, but the surface utilities below outrank that
        // fill, so the checked surface is set by hand: a white tick needs the green behind it in both themes.
        'w-4 h-4 text-neon-green-600 bg-white border-gray-300 checked:bg-neon-green-600 checked:border-transparent',
        'dark:bg-[#2c2c2c] dark:border-gray-500 dark:text-neon-green-500 dark:checked:bg-neon-green-500 dark:checked:border-transparent',
        'focus:ring-0 focus:ring-offset-0 disabled:opacity-40 disabled:cursor-not-allowed',
      )}
      {...props}
    />
  );
};

export const CheckBox = memo(CheckBox_);
